<template>
  <div class="checkbox-container">
    <input
      type="checkbox"
      v-bind="$attrs"
      :checked="value"
      @change="$emit('input', $event.target.checked)"
    >
    <label v-if="label" style="margin-left: 5px">{{label}}</label>
    <label v-else style="margin-left: 5px"><slot></slot></label>
  </div>
</template>
<script>
  export default {
    inheritAttrs: false,
    props: {
      value: [String, Number],
      check: {
        type: Boolean,
        default: false
      },
      label: String,
      icon: {
        type: String,
        default: ""
      },
      fakelabel: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/formGroupCheckbox.vue